import type {OutputMaterialSockets} from "#material/nodes/base/output/definition"
import type {MaterialNodeParameters, MaterialNodeSettings} from "#material/sockets/parameters"
import type {Version} from "@cm/graph-v3"

type Current = MaterialNodeParameters<OutputMaterialSockets>
type Previous = Omit<Current, "settings"> & {
    settings: Omit<MaterialNodeSettings<OutputMaterialSockets>, "displacementEnabled"> & {displacementDisabled?: boolean}
}

/** Displacement used to be stored as its own negation, which no plain checkbox could show. */
export const invertDisplacementDisabled: Version<Previous, Current> = {
    toNextVersion: ({settings: {displacementDisabled, ...settings} = {}, ...parameters}) => ({
        ...parameters,
        settings: displacementDisabled === undefined ? settings : {...settings, displacementEnabled: !displacementDisabled},
    }),
}
